export const BENEFICIO_FARMACIA_ROUTE = "/plano-de-medicamentos";

export const BENEFICIO_FARMACIA_ICON = "capsules";

function normalizeLabel(label?: string) {
  return String(label || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

export function beneficioFarmaciaMenuItem() {
  return {
    Label: "Plano de medicamentos",
    Icon: BENEFICIO_FARMACIA_ICON,
    Icone: BENEFICIO_FARMACIA_ICON,
    View: BENEFICIO_FARMACIA_ROUTE,
    Desktop: false,
    Description: "Créditos para comprar medicamentos em farmácias credenciadas"
  };
}

function isBeneficioFarmaciaMenu(menu) {
  const label = normalizeLabel(menu?.Label);
  if (label.includes("beneficio farmacia") || label.includes("plano de medicamentos")) return true;
  return String(menu?.View || "").includes(BENEFICIO_FARMACIA_ROUTE);
}

export function withBeneficioFarmaciaMenuItem(menus: any[] = []) {
  const list = Array.isArray(menus) ? [...menus] : [];
  const existingIndex = list.findIndex(isBeneficioFarmaciaMenu);
  const item = beneficioFarmaciaMenuItem();

  if (existingIndex >= 0) {
    list[existingIndex] = { ...list[existingIndex], ...item };
    return list;
  }

  const equipeIndex = list.findIndex(menu => normalizeLabel(menu?.Label).includes("equipe de saude"));
  if (equipeIndex >= 0) {
    list.splice(equipeIndex + 1, 0, item);
    return list;
  }

  const avaliacaoIndex = list.findIndex(menu => normalizeLabel(menu?.Label).includes("avaliacao de prestador"));
  if (avaliacaoIndex >= 0) {
    list.splice(avaliacaoIndex, 0, item);
    return list;
  }

  list.push(item);
  return list;
}

export const PLANO_MEDICAMENTOS_NOTICE_INDEX = "plano-medicamentos";

export function planoMedicamentosNotice() {
  return {
    TipoAviso: 1,
    Alerta: "N",
    Cor: "var(--colors-light-primary-navy-blue)",
    Icone: BENEFICIO_FARMACIA_ICON,
    Mensagem: "Aproveite seu novo benefício: plano de medicamentos Vidalink.",
    MensagemPopUp:
      "Com a parceria entre Omint e Vidalink, você e seus beneficiários contam com um saldo mensal para a compra de medicamentos em farmácias credenciadas em todo o Brasil. Os valores disponíveis seguem o plano contratado pela sua empresa.|Para aproveitá-lo, baixe o app VidaLink, siga os passos para o primeiro acesso e confira todos os detalhes do seu benefício.",
    Link: BENEFICIO_FARMACIA_ROUTE,
    index: PLANO_MEDICAMENTOS_NOTICE_INDEX
  };
}

export function withPlanoMedicamentosNotice(messages: any[] = []) {
  const list = Array.isArray(messages) ? [...messages] : [];
  const notice = planoMedicamentosNotice();
  const existingIndex = list.findIndex(
    message => message?.index === PLANO_MEDICAMENTOS_NOTICE_INDEX || message?.Link === BENEFICIO_FARMACIA_ROUTE
  );

  if (existingIndex >= 0) {
    list[existingIndex] = { ...list[existingIndex], ...notice };
    return list;
  }

  return [notice, ...list];
}
